import { createFileRoute } from "@tanstack/react-router";
import { ClassStep } from "#/modules/les.planning/components/preparation-steps";
import { classStepOptions } from "#/modules/les.planning/preparation-routes";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lesson/$lesson/teacher/les-info/les/class",
)({ ...classStepOptions, component: Step });

function Step() {
  const navigate = Route.useNavigate();
  return (
    <ClassStep
      data={Route.useLoaderData()}
      search={Route.useSearch()}
      onChange={(patch) =>
        void navigate({
          search: (prev) => ({ ...prev, ...patch }),
          replace: true,
          resetScroll: false,
        })
      }
    />
  );
}
